import { render, staticRenderFns } from "./OrderStatusFilter.vue?vue&type=template&id=b3c35608&scoped=true"
import script from "./OrderStatusFilter.vue?vue&type=script&lang=js"
export * from "./OrderStatusFilter.vue?vue&type=script&lang=js"
import style0 from "./OrderStatusFilter.vue?vue&type=style&index=0&id=b3c35608&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c35608",
  null
  
)

export default component.exports